var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55556 23.2222H13.4444C13.4444 24.5667 12.3444 25.6667 11 25.6667C9.65556 25.6667 8.55556 24.5667 8.55556 23.2222ZM22 20.7778V22H0V20.7778L2.44444 18.3333V11C2.44444 7.21111 4.88889 3.91111 8.55556 2.81111V2.44444C8.55556 1.1 9.65556 0 11 0C12.3444 0 13.4444 1.1 13.4444 2.44444V2.81111C17.1111 3.91111 19.5556 7.21111 19.5556 11V18.3333L22 20.7778ZM17.1111 11C17.1111 7.57778 14.4222 4.88889 11 4.88889C7.57778 4.88889 4.88889 7.57778 4.88889 11V19.5556H17.1111V11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.f99d50fa7ac9a6829afe4c6a5ca3e7c5.svg";
export { ForwardRef as ReactComponent };